import axios from 'axios';
// import { key } from '@/constants/dict'



const loginKeyreq = (method, url, params) => {
        return axios({
                method: method,
                url: url,
                timeout: 5000,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                data: params,
                traditional: true,
                transformRequest: [
                    function(data) {
                        let ret = ''
                        for (let it in data) {
                            ret +=
                                encodeURIComponent(it) +
                                '=' +
                                encodeURIComponent(data[it]) +
                                '&'
                        }
                        return ret
                    }
                ]
            }).then(res => {
                if (!res) {
                    throw new Error('超时无响应');
                }
                if (!res.data) {
                    throw new Error('响应数据格式异常');
                }
                return res.data;
            })
            .catch(error => {
                let errorMessage = '系统异常，请稍后重试！';

                // 1. 最高优先级：直接检测timeout相关的错误特征
                if (error.code === 'ECONNABORTED' ||
                    (error.message && (error.message.includes('timeout') || error.message.includes('超时')))) {
                    errorMessage = '请求超时，请稍后再试！';
                }
                // 2. 处理then回调中抛出的错误，将其映射为更友好的消息
                else if (error.message === '无响应数据' || error.message === '响应数据格式异常') {
                    // 这些错误在网络不稳定或超时时可能触发，统一处理为网络问题
                    errorMessage = '网络连接异常，请检查网络后重试';
                }
                // 3. 其他错误处理保持不变
                else if (error.response) {
                    errorMessage = `请求错误: ${error.response.status} ${error.response.statusText}`;
                } else if (error.request) {
                    // 注意：这里不再使用"网络连接超时"，而是更通用的"网络连接异常"
                    errorMessage = '网络连接异常，请检查网络后重试';
                } else if (error.message && error.message.includes('ECONNREFUSED')) {
                    errorMessage = '服务暂时不可用，请稍后重试';
                } else {
                    errorMessage = error.message || errorMessage;
                }

                console.error(`[${new Date().toISOString()}]`, errorMessage, error);

                // 返回统一的错误格式
                return Promise.reject({
                    code: 500,
                    message: errorMessage,
                    detail: process.env.NODE_ENV === 'development' ? error.stack : undefined
                });
            });
    }
    // 登录请求方法
const allreq = (method, url, params) => {
    return axios({
            method: method,
            url: url,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
            },
            data: params,
            traditional: true,
            transformRequest: [
                function(data) {
                    let ret = ''
                    for (let it in data) {
                        ret +=
                            encodeURIComponent(it) +
                            '=' +
                            encodeURIComponent(data[it]) +
                            '&'
                    }
                    return ret
                }
            ]
        }).then(res => {
            if (!res) {
                throw new Error('超时无响应');
            }
            if (!res.data) {
                throw new Error('响应数据格式异常');
            }
            return res.data;
        })
        .catch(error => {
            let errorMessage = '系统异常，请稍后重试！';

            // 1. 最高优先级：直接检测timeout相关的错误特征
            if (error.code === 'ECONNABORTED' ||
                (error.message && (error.message.includes('timeout') || error.message.includes('超时')))) {
                errorMessage = '请求超时，请稍后再试！';
            }
            // 2. 处理then回调中抛出的错误，将其映射为更友好的消息
            else if (error.message === '无响应数据' || error.message === '响应数据格式异常') {
                // 这些错误在网络不稳定或超时时可能触发，统一处理为网络问题
                errorMessage = '网络连接异常，请检查网络后重试';
            }
            // 3. 其他错误处理保持不变
            else if (error.response) {
                errorMessage = `请求错误: ${error.response.status} ${error.response.statusText}`;
            } else if (error.request) {
                // 注意：这里不再使用"网络连接超时"，而是更通用的"网络连接异常"
                errorMessage = '网络连接异常，请检查网络后重试';
            } else if (error.message && error.message.includes('ECONNREFUSED')) {
                errorMessage = '服务暂时不可用，请稍后重试';
            } else {
                errorMessage = error.message || errorMessage;
            }

            console.error(`[${new Date().toISOString()}]`, errorMessage, error);

            // 返回统一的错误格式
            return Promise.reject({
                code: 500,
                message: errorMessage,
                detail: process.env.NODE_ENV === 'development' ? error.stack : undefined
            });
        });
};
const resourceReq = (method, url, params) => {
        return axios({
                method: method,
                url: url,
                timeout: 60000,
                headers: {
                    'Content-Type': 'application/json',
                },
                data: params,
            }).then(res => {
                if (!res) {
                    throw new Error('超时无响应');
                }
                if (!res.data) {
                    throw new Error('响应数据格式异常');
                }
                return res.data;
            })
            .catch(error => {
                let errorMessage = '系统异常，请稍后重试！';

                // 1. 最高优先级：直接检测timeout相关的错误特征
                if (error.code === 'ECONNABORTED' ||
                    (error.message && (error.message.includes('timeout') || error.message.includes('超时')))) {
                    errorMessage = '请求超时，请稍后再试！';
                }
                // 2. 处理then回调中抛出的错误，将其映射为更友好的消息
                else if (error.message === '无响应数据' || error.message === '响应数据格式异常') {
                    // 这些错误在网络不稳定或超时时可能触发，统一处理为网络问题
                    errorMessage = '网络连接异常，请检查网络后重试';
                }
                // 3. 其他错误处理保持不变
                else if (error.response) {
                    errorMessage = `请求错误: ${error.response.status} ${error.response.statusText}`;
                } else if (error.request) {
                    // 注意：这里不再使用"网络连接超时"，而是更通用的"网络连接异常"
                    errorMessage = '网络连接异常，请检查网络后重试';
                } else if (error.message && error.message.includes('ECONNREFUSED')) {
                    errorMessage = '服务暂时不可用，请稍后重试';
                } else {
                    errorMessage = error.message || errorMessage;
                }

                console.error(`[${new Date().toISOString()}]`, errorMessage, error);

                // 返回统一的错误格式
                return Promise.reject({
                    code: 500,
                    message: errorMessage,
                    detail: process.env.NODE_ENV === 'development' ? error.stack : undefined
                });
            });
    }
    // 通用公用方法
const req = (method, url, params) => {
    return axios({
        method: method,
        url: url,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            token: localStorage.getItem('logintoken')
        },
        data: params,
        traditional: true,
        transformRequest: [
            function(data) {
                let ret = ''
                for (let it in data) {
                    ret +=
                        encodeURIComponent(it) +
                        '=' +
                        encodeURIComponent(data[it]) +
                        '&'
                }
                return ret
            }
        ]
    }).then(res => res.data);
};

export {
    loginKeyreq,
    allreq,
    req,
    resourceReq
}